import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { TelaUserGrupoService } from './tela-user-grupo.service';
import { Location } from '@angular/common';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-tela-user-grupo',
  templateUrl: './tela-user-grupo.component.html'
})
export class TelaUserGrupoComponent implements OnInit {

  public spinnerLoad: boolean = false;

  public formMenusGrupo: FormGroup = null;
  public grupoId: any = null;
  public grupoDescription:any = null;
  public produtoId: any = null;

  public listMenus: any = [];

  public listGrupoMenus: any = [];


  constructor(
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: TelaUserGrupoService,
    private encriptyService: EncriptyUtilService,
    private location: Location
  ) {

    this.route.queryParamMap.subscribe(params => {
      this.grupoId = this.encriptyService.decriptyBySecretKey(params.get('grupoId'))
      this.produtoId = this.encriptyService.decriptyBySecretKey(params.get('produtoId'))
    });

    this.formMenusGrupo = this.formBuilder.group({
      grupoId: [this.grupoId],
      produtoId: [this.produtoId]
    });
  }

  ngOnInit() {

  }


}
